module.exports = __webpack_public_path__ + "img/15_maska_klever.b77f116.svg";